/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ShopSearchProductFiltersRequest} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearchProductFilters.pb'
import {ShopSearchProductFiltersResponse} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearchProductFilters.pb'


export const shopSearchProductFilters = (request: ShopSearchProductFiltersRequest, options?: CashRequestOptions) => post<ShopSearchProductFiltersRequest, ShopSearchProductFiltersResponse>("/2.0/cash/shop-search-product-filters", request, {...options, rejectOnError: true })